import { defineMessages } from 'react-intl'

/* eslint-disable max-len */

export default defineMessages({
  info: '<p> Thank you for your interest in our website and company. Despite careful content control, we are unable to assume liability for links to third-party content.</p><p>The protection of personal data of our customers, distributors, suppliers and partners ("business partners") is an important concern for us. Therefore, we provide you with the following information:</p>',
  infoLink: 'Data privacy statement',
  ceo: 'CEO',
  register: 'Company register',
  idnumber: 'Sales tax identification number',
  dataPrivacyPdfPath: 'https://www.freshcells.de/privacy-policy/'
})
